function deepGet(obj, path) {
  let value = obj;

  const pathParts = path.split('.');

  for (let i = 0; i < pathParts.length; i += 1) {
    if (typeof value === 'undefined') {
      return undefined;
    }

    value = value[pathParts[i]];
  }

  return value;
}

function parseValue(value) {
  if (value === '') {
    return undefined;
  }

  try {
    const parsedValue = JSON.parse(value);

    return parsedValue;
  } catch (error) {
    return value;
  }
}

function on(name, func, options = {}, container) {
  container.addEventListener(
    name,
    (event) => {
      if (options.preventDefault) event.preventDefault();

      const { target, detail } = event;

      func({
        target,
        data: detail,
      });
    },
    options,
  );
}

export { deepGet, parseValue, on };
